import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { CursorService } from '../cursor_animation/cursor.service';

@Injectable({
    providedIn: 'root'
})
export class CursorColorService {
    constructor(private router: Router, private cursorService: CursorService) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                // Change cursor color to white when navigation starts
                this.cursorService.changeCursorColor('white');
            } else if (event instanceof NavigationEnd) {
                // Change cursor color back to default color when navigation ends
                this.cursorService.changeCursorColor('#8d0a1f');
            }
        });
    }
}
